import cx from "classnames"
import { useState } from "react"
import { usePropsObject } from "@/lib/contexts/appContext"
import ImageVideo from "@/common/partials/imageVideo"
import styles from "./video-teasers.module.css"
import Block from "@/components/wrappers/block"
import TextVideoBlock from "@/common/partials/textVideoBlock/textVideoBlock"
import ArticleContent from "@/common/article/content"
import BlockHeader from "@/common/partials/block-header/block-header"
import Button from "@/common/button/button"

export default function VideoTeasers({ block }) {
  const { button, videos, heading, text } = block.attrs
  const [hovered, setHovered] = useState(false)
  if (videos.length === 0) {
    return null
  }

  let mainArticle
  let blurbVideos = []
  videos.forEach((video, index) => {
    if (index === 0) {
      mainArticle = video
    } else {
      blurbVideos.push(video)
    }
  })

  return (
    <Block width="bleed" block={block}>
      {heading && text && (
        <header className={styles.header}>
          <BlockHeader {...{ heading, text }} className="inner-header" />
        </header>
      )}
      <TextVideoBlock
        gap={blurbVideos.length > 0 ? "none" : "normal"}
        layout="left"
        hovered={hovered}
        setHovered={setHovered}
        data={{
          url: mainArticle.video,
          poster: {
            url: mainArticle.image.url,
            alt: mainArticle.image.alt,
            sizes: "(max-width: 1024px) 100vw, (min-width: 1024px) 50vw"
          }
        }}
        className={styles.mainArticle}>
        <ArticleContent
          article={mainArticle}
          hovered={hovered}
          setHovered={setHovered}
        />
        {blurbVideos.length === 0 && button.url && (
          <Button
            theme={button.theme ?? "lime"}
            tagName="a"
            ariaLabel={button.label}
            href={button.url}
            target={button.target}
            className={styles.articleButton}>
            {button.label}
          </Button>
        )}
      </TextVideoBlock>
      {blurbVideos.length > 0 && (
        <div className={styles.plate}>
          <div className={styles.wrapper}>
            {blurbVideos.map((article, index) => {
              return (
                <VideoBlurb key={`blurbVideo-${index}`} article={article} />
              )
            })}
          </div>
          {button?.url && (
            <div className={styles.buttonWrapper}>
              <Button
                theme={button.theme ?? "light-lime"}
                tagName="a"
                ariaLabel={button.label}
                href={button.url}
                target={button.target}
                className={styles.button}>
                {button.label}
              </Button>
            </div>
          )}
        </div>
      )}
    </Block>
  )
}
const VideoBlurb = ({ article }) => {
  const [hovered, setHovered] = useState(false)
  const { theme } = usePropsObject()
  article.tag = false
  return (
    <div
      className={cx({
        "text-white": theme?.txtColor === "white"
      })}>
      <ImageVideo
        data={article}
        className={`block mb-3`}
        hovered={hovered}
        aspectRatio="aspect-w-16 aspect-h-12"
        onMouseLeave={() => {
          setHovered(false)
        }}
        onMouseEnter={() => {
          setHovered(true)
        }}
      />
      <ArticleContent
        article={article}
        hovered={hovered}
        setHovered={setHovered}
      />
    </div>
  )
}
